import { useQuery } from '@tanstack/react-query';
import { getSyncFilesList } from '../../../../shared/service/selfService';
import { SyncFilesListResponse } from '../types';

const DEFAULT_PAGE_SIZE = 20;

export default function useSyncFilesList(
  page: number = 1,
  limit: number = DEFAULT_PAGE_SIZE,
) {
  return useQuery<SyncFilesListResponse>({
    queryKey: ['sync-files-list', page, limit],
    queryFn: () => getSyncFilesList(page, limit),
  });
}
